import React, { useEffect} from "react";
import { TextField, Grid, Box, Typography, Stack} from "@mui/material";
import OffSpe from "../ui/dynamicInputList";

export default function DonForm(props) {

    useEffect(()=>{}, [props.offSpe_fede, props.offSpe_local])

    return(
        <Box>
            <Typography variant="h6" sx={{marginBottom:'15px', fontWeight:'bold', textDecoration:'underline'}}>Don: </Typography> 
            <Stack direction='row' spacing={5} alignItems='center' marginBottom={2}>
                <TextField
                fullWidth
                onFocus={()=>{if(props.dime===0) props.setDime('')}}
                name="dime"
                label="Dîme (en €)"
                inputProps={{step:"0.01", min:'0'}}
                type="number"
                value={props.dime}
                onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0) {
                    props.setDime(Number(e.target.value))
                }else if(e.target.value===''){
                    props.setDime('')
                }}}/>
                <TextField
                fullWidth
                onFocus={()=>{if(props.off_global===0) props.setOff_global('')}}
                name="offrande globale"
                label="Offrande Globale (en €)"
                inputProps={{step:"0.01", min:'0'}}
                type="number"
                value={props.off_global}
                onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                    props.setOff_global(Number(e.target.value))
                }else if(e.target.value===''){
                    props.setOff_global('')
                }}}/>
            </Stack>
            <Grid container columnSpacing={5} rowSpacing={2} >
                {props.offSpeLabel_fede.length>0 &&<Grid item sm={6}>
                    <Typography sx={{margin:'0 0 15px 20px', textAlign:'center', fontWeight:'bold'}}>Offrandes spécifiées FÉDÉRALES</Typography> 
                    <OffSpe
                    eglise={props.eglise}
                    label="Offrande spécifiée (fédéral)"
                    offSpeLabel={props.offSpeLabel_fede}
                    offSpe={props.offSpe_fede}
                    setOffSpe={props.setOffSpe_fede}
                    setOffSpeLabel={props.setOffSpeLabel_fede}
                    canAdd={JSON.parse(sessionStorage.getItem('eglise'))?.type==='fédération'}
                    isFedOff={true}/>
                </Grid>}
                {props.eglise.type==='église' &&<Grid item sm={6}>
                    <Typography sx={{margin:'0 0 15px 20px', textAlign:'center', fontWeight:'bold'}}>Offrandes spécifiées LOCALES</Typography> 
                    <OffSpe
                    eglise={props.eglise}
                    label="Offrande spécifiée (Local)"
                    offSpeLabel={props.offSpeLabel_local}
                    offSpe={props.offSpe_local}
                    setOffSpe={props.setOffSpe_local}
                    setOffSpeLabel={props.setOffSpeLabel_local}
                    canAdd={false}/>
                </Grid>}
            </Grid>
            <Typography variant="h5" color='primary' sx={{fontWeight:'bold', marginBlock:2, marginLeft:5}}>TOTAL DON: {props.total?.toFixed(2)}€</Typography> 
        </Box>
    )
}